import { useFormik } from "formik";
import * as Yup from "yup";

const useFormCommerce = (onSubmit, afterSubmit, initialValues, isEditMode) => {
  const validationSchema = Yup.object({
    name: Yup.string().required("Nombre de usuario es requerido"),
    localization: Yup.string().required("La localización es requerida"),
    code: Yup.number()
      .required("El código es requerido")
      .positive("El código debe ser un número positivo"),
    status: Yup.boolean().required("El estado es requerido"),
  });

  // Asegurar valores iniciales completos
  const safeInitialValues = {
    name: "",
    localization: "",
    code: "",
    status: true,
    ...initialValues,
  };

  return useFormik({
    initialValues: safeInitialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await onSubmit(values);
        afterSubmit();
      } finally {
        setSubmitting(false);
      }
    },
    enableReinitialize: true,
  });
};

export default useFormCommerce;
